import { createContext } from 'react';
import type { TextInputDialogOptions, TextInputDialogResult } from '../types';

export type TextInputDialogContextValue = {
  openTextInputDialogBase: <
    T extends Record<string, string | number | boolean> = Record<string, string | number | boolean>,
  >(
    parentId: string,
    options: TextInputDialogOptions,
  ) => Promise<TextInputDialogResult<T>>;
  closeTextInputDialogOnParentUnmount: (parentId: string) => void;
};

const TextInputDialogContext = createContext<TextInputDialogContextValue>({
  openTextInputDialogBase() {
    throw new Error('Missing ConfirmProvider');
  },
  closeTextInputDialogOnParentUnmount() {
    // No provider, no open dialog to close.
  },
});

export default TextInputDialogContext;
